import AssessmentInputs from './AssessmentInputs';

export default AssessmentInputs;
